import React, { ReactNode, FunctionComponent, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

export interface Props {
  title: ReactNode
  content: ReactNode
  attribution: JSON
}

export const UserBannerInfoCard: FunctionComponent<Props> = ({
  title,
  content,
  attribution,
}) => {
  const { id } = useParams<{ id: string }>()
  const [isHovering, setIsHovering] = useState(false)

  return (
    <div data-test="user-banner-info-card" className="user-banner__info-card">
      <h4 className="user-banner__info-card__title">{title}</h4>
      <hr className="user-banner__info-card__hr" />
      <div>{content}</div>
      {attribution?.sms_error && (
        <Link
          to={`/users/${id}/edit`}
          title="Click to edit number"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          style={{
            color: 'red',
            marginTop: '8px',
            fontSize: '12px',
            display: 'inline-block',
            textDecoration: isHovering ? 'underline' : 'none',
          }}
        >
          SMS {attribution?.sms_error?.status.toUpperCase()} -{' '}
          {attribution?.sms_error?.msg}. Please change your phone number or contact support.
        </Link>
      )}
    </div>
  )
}

UserBannerInfoCard.displayName = 'UserBannerInfoCard'
